import { render, staticRenderFns } from "./deleteOwnerRepair.vue?vue&type=template&id=1479b9f8"
import script from "./deleteOwnerRepair.vue?vue&type=script&lang=js"
export * from "./deleteOwnerRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports